import { Chip, Tooltip } from '@mui/material';
import BoltIcon from '@mui/icons-material/Bolt';
import { useTranslation } from 'react-i18next';
import { useCredits } from '../../contexts/CreditContext';
import { formatNumber } from '../../i18n/format';

/**
 * Header credit balance (agency-only). Shows total available credits; turns
 * amber below 10% of the monthly allocation. Click → top-up modal.
 */
export default function CreditBalanceChip() {
  const { t } = useTranslation();
  const { isAgency, balance, openTopup } = useCredits();
  if (!isAgency || !balance) return null;

  const { available, subscriptionCredits, topupCredits, monthlyAllocation } = balance;
  const low = monthlyAllocation ? available < monthlyAllocation * 0.1 : available <= 0;

  const tooltipTitle =
    t('creditChip.tooltip', { subscription: subscriptionCredits, topup: topupCredits }) +
    (balance.reserved ? t('creditChip.tooltipReserved', { reserved: balance.reserved }) : '');

  return (
    <Tooltip title={tooltipTitle}>
      <Chip
        data-tour="credit-balance"
        icon={<BoltIcon fontSize="small" />}
        label={t('creditChip.label', { credits: formatNumber(available) })}
        size="small"
        color={low ? 'warning' : 'default'}
        variant={low ? 'filled' : 'outlined'}
        onClick={() => openTopup()}
        sx={{ fontWeight: 600, cursor: 'pointer' }}
      />
    </Tooltip>
  );
}
